// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".courier-user .el-image-viewer__img {\n  padding: 10px;\n  background-color: white;\n}", ""]);
// Exports
module.exports = exports;
